import api from "../api";

const basePath = "ai";

export const getAiConversations = async () => {
  return api.getApi().get(api.getBaseUrl() + `${basePath}/conversations`);
};

export const createAiConversation = async (payload = {}) => {
  return api
    .getApi()
    .post(api.getBaseUrl() + `${basePath}/conversations`, payload);
};

export const getAiConversationMessages = async (conversationId) => {
  return api
    .getApi()
    .get(
      api.getBaseUrl() + `${basePath}/conversations/${conversationId}/messages`
    );
};

export const sendAiConversationMessage = async (conversationId, message) => {
  return api
    .getApi()
    .post(
      api.getBaseUrl() + `${basePath}/conversations/${conversationId}/messages`,
      {
        message,
      }
    );
};

export const streamAiConversationMessage = async (
  conversationId,
  message,
  onChunk,
  onFinish,
  onError
) => {
  const token = api.getToken();
  const url =
    api.getBaseUrl() + `${basePath}/conversations/${conversationId}/messages/stream`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ message }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      let errorMessage = response.statusText;
      try {
        const errorJson = JSON.parse(errorText);
        errorMessage = errorJson.message || errorMessage;
      } catch (e) {}
      throw new Error(errorMessage);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n\n");
      buffer = lines.pop(); // Keep the last incomplete chunk

      for (const line of lines) {
        if (line.startsWith("data: ")) {
          const dataStr = line.slice(6);
          try {
            const data = JSON.parse(dataStr);
            if (data.type === "error") {
              onError(new Error(data.message));
              return;
            }
            onChunk(data);
            if (data.type === "done") {
              onFinish(data);
              return;
            }
          } catch (e) {
            console.error("Stream parse error", e);
          }
        }
      }
    }
    onFinish();
  } catch (error) {
    onError(error);
  }
};
